/**
 * “需要掌握的信息”的逐项详解。
 *
 * 森林火灾与危化品事故共用这一套结构：每一项信息都要能回答
 * 为什么需要它、需要拿到什么、从哪里获得、缺失时会怎样、它能说明和不能说明什么，
 * 以及哪些官方资料与它直接相关。
 *
 * 这里只放说明文字，不放结论：说明本身也不构成现场判断、行动阈值或授权。
 */
export interface ResearchInformationRelation {
  /** 对应的官方资料 id，必须能在该场景的资料表中解析到。 */
  readonly id: string;
  /** 这份资料在这一项信息上具体支持什么。 */
  readonly relation: string;
}

export interface ResearchInformationDetail {
  readonly why: string;
  readonly what: readonly string[];
  readonly risk: string;
  readonly boundary: string;
  readonly sources: readonly ResearchInformationRelation[];
}

export type ResearchInformationDetailMap = Readonly<Record<string, ResearchInformationDetail>>;

/** 逐项详解以“问题 + 信息名称”为键：名称是页面上唯一的锚点，不依赖数组顺序。 */
export function informationDetailKey(issueKey: string, name: string) {
  return issueKey + '|' + name;
}

/** 资料卡在抽屉里的统一形状，两个场景各自映射到它。 */
export interface ResearchDrawerSource {
  readonly id: string;
  readonly title: string;
  readonly meta: string;
  readonly summary: string;
  /** 资料性质或状态说明。没有可写的具体说明时留空，不补通用套话。 */
  readonly caveat?: string;
  readonly relation: string;
  readonly url: string;
  readonly documentUrl?: string;
  readonly documentLabel?: string;
}

export interface ResearchDrawerCase {
  readonly id: string;
  readonly title: string;
  readonly meta: string;
  readonly summary: string;
  readonly caveat?: string;
  readonly url: string | null;
}
